// extracted by mini-css-extract-plugin
module.exports = {"footer":"xAbLXdZT","wrap":"__5WbBZ0ep","menusWrap":"__4C5Be1Bu","contact":"wqRg8ENw","k":"UEmWOr6E","v":"cbyhZYqV","qrcode":"I6bTi8Uj"};